import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import { i18n } from "discourse-i18n";

export default <template>
  <PluginOutlet
    @name="community-navigation-creator-resources-page"
    @outletArgs={{lazyHash
      type=@model.type
      sort=@model.sort
      page=@model.page
    }}
  >
    <section class="community-placeholder-page">
      <h1 class="community-placeholder-page__title">{{i18n
          "community_navigation.resource_sharing"
        }}</h1>
      <p class="community-placeholder-page__description">{{i18n
          "community_navigation.placeholders.resource_sharing"
        }}</p>
    </section>
  </PluginOutlet>
</template>;
